<template>
  <div class="top">
    <div class="top-pattern"></div>
    <div class="wrapper">
      <div class="top-img"></div>
      <div class="left">
        <div class="user-info">
          <div class="info">
            <span class="name"
              >{{ (currentUser && currentUser.name) || "No Name" }},
              <strong
                :class="{
                  nameLong:
                    currentVars &&
                    currentVars.find((x) => x.name == 'Position') &&
                    currentVars.find((x) => x.name == 'Position').value.length >
                      22,
                }"
              >
                {{
                  (currentVars &&
                    currentVars.find((x) => x.name == "Position") &&
                    currentVars.find((x) => x.name == "Position").value) ||
                  "No Position"
                }}</strong
              ></span
            >
            <span class="address">
              {{
                (currentVars &&
                  currentVars.find((x) => x.name == "City") &&
                  currentVars.find((x) => x.name == "City").value) ||
                "No City"
              }}
            </span>
          </div>
        </div>
        <div class="about">
          <span class="head"
            >Welcome to <br />
            {{ isItPlatformaUser ? "Integrity Solutions" : "Luxoft" }}
            Rewards</span
          >
          <span class="desc open-sans">
            Keep doing what you do, only now get a little something extra for
            it. Earn points when you complete certain actions, and then exchange
            these points for exciting rewards. Good luck!
          </span>
          <a href="#" class="red-btn" @click.prevent="isOpenPopup = true"
            >More info</a
          >
        </div>
      </div>
      <div class="right">
        <div class="ball" :class="{ type_full: !nextGift }">
          <span class="ball-num" @click.prevent="openHistory">
            <strong>{{ currentPoints || 0 }} </strong>
          </span>
          <span class="ball-num" @click.prevent="openHistory">
            general {{ currentPoints | pluralize("point,points,points") }}
          </span>
          <a
            href="#"
            class="right-btn"
            @click.prevent="$eventBus.$emit('scrollToGifts')"
          ></a>
        </div>
        <div
          class="ball"
          :class="{ type_full: !nextGift }"
          style="background-color: #f1f3f6"
          v-if="
            p2pConfig['edu'] &&
            !['Serbia', 'Belgrade', 'Other Serbia Locations'].includes(city)
          "
        >
          <span class="ball-num" @click.prevent="openHistory">
            <strong>{{ p2pConfig["edu"].points || 0 }} </strong>
          </span>
          <span class="ball-num" @click.prevent="openHistory">
            learning
            {{ p2pConfig["edu"].points | pluralize("point,points,points") }}
          </span>
          <a
            href="#"
            class="right-btn"
            @click.prevent="$eventBus.$emit('scrollToGifts')"
          ></a>
        </div>
        <div v-if="nextGift" class="next">
          <img class="img img1" :src="nextGift.image" />
          <span class="text open-sans">
            <span class="text-wrap">
              {{ nextGift.points - currentPoints }} points left until your next
              reward
            </span>
          </span>
        </div>
      </div>
    </div>

    <!-- Popup -->
    <transition name="s_popup_transition">
      <div class="popup" v-if="isOpenPopup">
        <div
          class="popup-inner popup-inner-about"
          v-on-clickaway="
            () => {
              isOpenPopup = false;
            }
          "
        >
          <a href="#" class="close" @click.prevent="isOpenPopup = false"></a>
          <span class="head"> Rules of the rewards program </span>
          <div class="desk">
            <br /><b>Introduction</b><br /><br />
            Dear colleagues,<br /><br />

            We know you do a great job promoting Luxoft, carrying out your daily
            tasks, and doing the things that make our business grow bigger and
            better.<br />
            That’s why we decided to launch the Loyalty Program; it’s time you
            were rewarded for doing your part to bring Luxoft to new heights.<br /><br />

            We’re starting by rewarding certain specific activities, but there
            will be a lot of new initiatives and temporary activities that will
            allow you to earn even more points, so keep your eyes peeled.
            <br /><br />
            So go get what you’ve earned! Don’t hesitate to request your
            rewards!<br /><br /><br />

            <b>How do you earn bonus points?</b><br /><br />
            Here’s a list of activities that earn you rewards:<br /><br />
            <b>Speaking at an event</b> - give speeches, lectures, or workshops
            at industry events or internal community events, including LoGeek
            Nights.<br /><br />
            <b>Writing articles</b> – put your wise words in the external media,
            excluding social media.<br /><br />
            <b>Internal Mobility</b> - get the reward whether you’re the
            releasing manager, the receiving manager, or the internal candidate
            hired via Internal Mobility.<br /><br />
            <b>Writing a review on a job portal</b> - write a unique job review
            on a key job portal like Glassdoor, Indeed, etc.<br /><br />
            <b>Giving a feedback badge</b> – the first feedback badge given in
            the LuxTalent system will be rewarded with points once per year.<br /><br />
            <b>Finishing your probation period</b> – successfully complete your
            probation period.<br /><br />
            <b>Successfully providing a Junior/Regular reference</b> –
            successfully refer someone for a Junior (all specializations) or
            Regular (<a
              href="http://career.luxoft.com/referral/administrative-positions/"
              target="_blank"
              >Administrative specializations</a
            >) position. “Successfully referring” means that the referred person
            ended up passing his or her probation period.<br /><br />
            <b>Providing 2-3 successful references</b> – same as above for 2 or
            3 successful references within one financial year.<br /><br />
            <b>Providing 4+ successful references</b> – same as above for 4 or
            more successful references within one financial year.<br /><br />
            <b>Celebrating your work anniversary</b> – reaching a work
            anniversary in the company. And we’ve prepared a special bonus for
            those who celebrate their 5th, 10th, and 15th anniversary.<br /><br /><br />

            <b>How do you spend bonus points and receive rewards?</b
            ><br /><br />
            All your collected LuxCoins will be shown in your personal Loyalty
            Program account. As soon as you gather enough LuxCoins to get a
            reward, don’t hesitate to get what you’ve earned! Or hey, you could
            even collect event more LuxCoins and get more valuable reward. It’s
            your choice!<br /><br /><br />

            <b>Troubleshooting</b><br /><br />
            We all know that sometimes systems can suffer some delays or
            problems ☺. If you believe that some of activities are missing in
            your account or if there are any other issues with the Loyalty
            Program please send an email to
            <a href="mailto:loyalty@luxoft.com">loyalty@luxoft.com</a>. We’ll
            get in touch to solve the issue.<br /><br /><br />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { directive as onClickaway } from "vue-clickaway2";
export default {
  name: "AppMain",
  data() {
    return {
      isOpenPopup: false,
    };
  },
  directives: {
    onClickaway,
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentPoints",
      "nextGift",
      "currentVars",
      "isItPlatformaUser",
      "p2pConfig",
      "city",
    ]),
  },
  watch: {
    isOpenPopup(value) {
      let className = "lock-scroll";
      if (value) {
        document.getElementsByTagName("body")[0].style.top =
          -document.documentElement.scrollTop + "px";
        document.documentElement.classList.add(className);
      } else {
        document.documentElement.classList.remove(className);
        document.documentElement.scrollTop = -parseFloat(
          document.getElementsByTagName("body")[0].style.top.replace("px", "")
        );
      }
    },
  },
  methods: {
    onChangeAvatar(e) {
      let file = e.target && e.target.files && e.target.files[0];
      this.$store.dispatch("changeAvatar", file).then(() => {
        this.$store.dispatch("fetchUser");
      });
    },
    scrollToGift(id) {
      this.$eventBus.$emit("giftOpen", id);
    },
    openProfile() {
      this.$eventBus.$emit("popup", "profile");
    },
    openHistory() {
      this.$eventBus.$emit("popup", "history");
    },
  },
  mounted() {
    window.setInterval(() => {
      this.$store.dispatch("fetchUser");
    }, 2000);
  },
};
</script>
